import { makeAutoObservable } from 'mobx'
import { ReCaptchaV2Store } from 'entities/Auth/ui/ReCaptcha/ui/ReCaptchaV2'
import { ReCaptchaV3Store } from 'entities/Auth/ui/ReCaptcha/ui/ReCaptchaV3'
import type { IParamsGoogleRecaptcha } from 'entities/Auth/store/types'

export class ReCaptchaStore {
  private _reCaptchaV2Store = new ReCaptchaV2Store()
  private _reCaptchaV3Store = new ReCaptchaV3Store()

  constructor() {
    makeAutoObservable(this)
  }

  get reCaptchaV2Store() {
    return this._reCaptchaV2Store
  }

  get reCaptchaV3Store() {
    return this._reCaptchaV3Store
  }

  get visualChallengeToken() {
    return this._reCaptchaV2Store.token
  }

  get captchaToken() {
    return this._reCaptchaV3Store.token
  }

  setExecuteRecaptcha = async (action: string) => {
    this._reCaptchaV2Store.setError('')
    this._reCaptchaV2Store.setToken('')

    return await this._reCaptchaV3Store.initToken(action)
  }

  setVisualChallenge = async () => {
    return await this._reCaptchaV2Store.initToken()
  }

  checkServerError = (message: string) => {
    return message === 'visual_challenge_needed'
  }

  get disabled() {
    return !this.visualChallengeToken && !this.captchaToken
  }

  get params(): IParamsGoogleRecaptcha {
    if (this.captchaToken && this.visualChallengeToken) {
      return {
        captcha_token: this.captchaToken,
        visual_challenge_token: this.visualChallengeToken,
      }
    }

    if (this.visualChallengeToken) {
      return {
        visual_challenge_token: this.visualChallengeToken,
      }
    }

    return {
      captcha_token: this.captchaToken || '',
    }
  }
}
